import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {


  constructor(private readonly dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.data = data;
  }
  onNoClick() {
    this.dialogRef.close();
  }

  regist() {
    this.dialogRef.close({ event: 'override', data: "aas" })
  }
  view() {
    this.dialogRef.close({ event: 'view', data: "aas" })
  }

}
